// Boy Names (U.S.) card game data with rankings
export const BOY_NAME_CARDS = [
  {
    "id": 1,
    "name": "James",
    "rank": 1,
    "image": "/images/boyName/boyName_1.jpg"
  },
  {
    "id": 2,
    "name": "Michael",
    "rank": 2,
    "image": "/images/boyName/boyName_2.jpg"
  },
  {
    "id": 3,
    "name": "John",
    "rank": 3,
    "image": "/images/boyName/boyName_3.jpg"
  },
  {
    "id": 4,
    "name": "Robert",
    "rank": 4,
    "image": "/images/boyName/boyName_4.jpg"
  },
  {
    "id": 5,
    "name": "David",
    "rank": 5,
    "image": "/images/boyName/boyName_5.jpg"
  },
  {
    "id": 6,
    "name": "William",
    "rank": 6,
    "image": "/images/boyName/boyName_6.jpg"
  },
  {
    "id": 7,
    "name": "Richard",
    "rank": 7,
    "image": "/images/boyName/boyName_7.jpg"
  },
  {
    "id": 8,
    "name": "Joseph",
    "rank": 8,
    "image": "/images/boyName/boyName_8.jpg"
  },
  {
    "id": 9,
    "name": "Thomas",
    "rank": 9,
    "image": "/images/boyName/boyName_9.jpg"
  },
  {
    "id": 10,
    "name": "Christopher",
    "rank": 10,
    "image": "/images/boyName/boyName_10.jpg"
  },
  {
    "id": 11,
    "name": "Charles",
    "rank": 11,
    "image": "/images/boyName/boyName_11.jpg"
  },
  {
    "id": 12,
    "name": "Daniel",
    "rank": 12,
    "image": "/images/boyName/boyName_12.jpg"
  },
  {
    "id": 13,
    "name": "Matthew",
    "rank": 13,
    "image": "/images/boyName/boyName_13.jpg"
  },
  {
    "id": 14,
    "name": "Anthony",
    "rank": 14,
    "image": "/images/boyName/boyName_14.jpg"
  },
  {
    "id": 15,
    "name": "Mark",
    "rank": 15,
    "image": "/images/boyName/boyName_15.jpg"
  },
  {
    "id": 16,
    "name": "Steven",
    "rank": 16,
    "image": "/images/boyName/boyName_16.jpg"
  },
  {
    "id": 17,
    "name": "Donald",
    "rank": 17,
    "image": "/images/boyName/boyName_17.jpg"
  },
  {
    "id": 18,
    "name": "Andrew",
    "rank": 18,
    "image": "/images/boyName/boyName_18.jpg"
  },
  {
    "id": 19,
    "name": "Joshua",
    "rank": 19,
    "image": "/images/boyName/boyName_19.jpg"
  },
  {
    "id": 20,
    "name": "Paul",
    "rank": 20,
    "image": "/images/boyName/boyName_20.jpg"
  },
  {
    "id": 21,
    "name": "Kenneth",
    "rank": 21,
    "image": "/images/boyName/boyName_21.jpg"
  },
  {
    "id": 22,
    "name": "Kevin",
    "rank": 22,
    "image": "/images/boyName/boyName_22.jpg"
  },
  {
    "id": 23,
    "name": "Brian",
    "rank": 23,
    "image": "/images/boyName/boyName_23.jpg"
  },
  {
    "id": 24,
    "name": "Timothy",
    "rank": 24,
    "image": "/images/boyName/boyName_24.jpg"
  },
  {
    "id": 25,
    "name": "Ronald",
    "rank": 25,
    "image": "/images/boyName/boyName_25.jpg"
  },
  {
    "id": 26,
    "name": "Jason",
    "rank": 26,
    "image": "/images/boyName/boyName_26.jpg"
  },
  {
    "id": 27,
    "name": "George",
    "rank": 27,
    "image": "/images/boyName/boyName_27.jpg"
  },
  {
    "id": 28,
    "name": "Edward",
    "rank": 28,
    "image": "/images/boyName/boyName_28.jpg"
  },
  {
    "id": 29,
    "name": "Jeffrey",
    "rank": 29,
    "image": "/images/boyName/boyName_29.jpg"
  },
  {
    "id": 30,
    "name": "Ryan",
    "rank": 30,
    "image": "/images/boyName/boyName_30.jpg"
  }
];
